import { render, staticRenderFns } from "./MedicalInsuranceDiagnosis.vue?vue&type=template&id=289916db&scoped=true"
import script from "./MedicalInsuranceDiagnosis.vue?vue&type=script&lang=js"
export * from "./MedicalInsuranceDiagnosis.vue?vue&type=script&lang=js"
import style0 from "./MedicalInsuranceDiagnosis.vue?vue&type=style&index=0&id=289916db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289916db",
  null
  
)

export default component.exports